import React from 'react'

import Text from '../ui/text'

export const Edit = ({ config, value, onChange }) => (
  <Text type={config.inputType} placeholder={config.placeholder} value={value} onChange={onChange} />
)
